import React from 'react';
import TranslationService from "../../../app/services/TranslationService";


export class BooksList extends React.Component {
    constructor(props)
    {
        super(props);

        this.state = {
            opened: false
        };
    };

    listClass = () => {
        if (this.state.opened) {
            return 'selectable-list opened';
        }

        return 'selectable-list list';
    };

    elementOpen = (id) => {
        this.setState({
            opened: false
        });
        this.props.openElement(id);
    };

    getOpenedColor = () => {
        let color = 'main';

        let that = this;
        Object.keys(this.props.books).forEach(function(key) {
            if (that.props.books[key].id === that.props.bookId) {
                color = that.props.books[key].color;
            }
        });

        return color;
    }

    getOpenedTitle = () => {
        let title = TranslationService.trans(this.props.language, '_name');

        let that = this;
        Object.keys(this.props.books).forEach(function(key) {
            if (that.props.books[key].id === that.props.bookId) {
                title = that.props.books[key].title;
            }
        });

        return title;
    }

    renderData = () => {
        let rows = [];

        let that = this;
        Object.keys(this.props.books).forEach(function(key) {
            const color = that.props.books[key].color;

            rows.push(<div className={'imd-border-color-accent element book' + (that.props.books[key].id === that.props.bookId ? ' active' : '')}
                onClick={() => that.elementOpen(that.props.books[key].id)}
                key={key}
            >
                <div className={'imd-bg-' + color + (that.props.books[key].id === that.props.bookId ? ' active' : '')} />
                <span className={'imd-text-' + color}>
                    {that.props.books[key].title}
                </span>
            </div>);
        });

        return rows;
    };

    render() {
        return (
            <div className={this.listClass()}>
                <div className="list">
                    {this.renderData()}
                </div>

                <div className={'imd-bg-20-default imd-border-color-' + this.getOpenedColor() + ' active-element'} onClick={() => this.setState({opened: true})}>
                    <span>{this.getOpenedTitle()}</span>
                </div>
            </div>
        );
    }
}
